import { useHapticFeedback } from '@/hooks/useHapticFeedback';
import copy from 'copy-to-clipboard';

export const copyToClipboard = (text: string, message: string) => {
  const { triggerHapticFeedback } = useHapticFeedback();
  triggerHapticFeedback('medium');
  copy(text);
  setTimeout(() => alert(message));
};
